module.exports = __webpack_public_path__ + "img/art-20.19074e45.png";